<template>
    <div id="home-page" v-loading="loading">
        <pg-header id="mobile-header" @close="isClose=true"></pg-header>
        <div id="home-content" :class="{'is-close':isClose || !siteInfo.app_url }" v-if="!gameListLoading" ref="homePage" v-loading="gameListLoading"
            @touchmove="touchmove">
            <div class="home-wrap">
                <div class="notice-wrap">
                    <div class="notice-container" v-if="newsList.length > 0">
                        <img src="@/assets/images/icon_dt11.png" class="icon-notice" alt="">
                        <div class="notice-row">
                          <SeamlessScroll :data="newsList" :class-option="noticeOptions" class="seamless-warp">
                            <div class="notice-list">
                              <div class="notice-item" v-for="(item, index) in newsList" :key="index" @click="toPage('/customer?current=3')">{{ item.content }}</div>
                            </div>
                          </SeamlessScroll>
                        </div>
                        <i class="icon-msg" @click="toPage('/customer?current=1')"></i>
                    </div>
                    <div class="main-banner">
                        <swiper :options="swiperOption">
                            <swiper-slide v-for="(item, index) in bannerList" :key="index">
                                <div class="swiper-item" @click="bannerClick(item)">
                                    <img class="swiper-item-img" :src="item.url" @load="handlerLoadImage()" alt="">
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>

                        <div class="swiper-button-prev" v-show="bannerList.length > 0">
                            <div class="arrow left">
                                <Icon type='arrow-right-line' />
                            </div>
                        </div>
                        <div class="swiper-button-next" v-show="bannerList.length > 0">
                            <div class="arrow right">
                                <Icon type='arrow-right-line' />
                            </div>
                        </div>
                    </div>
                    <!--div class="jack-pot">
                        <div class="jp-bg">
                            <div class="count-box">
                                <span class="notranslate count-to">
                                    {{ cur_JPCount }}

                                </span>
                            </div>
                        </div>
                    </div-->
                </div>
                <div class="main-content">
                    <div class="m-bg">
                        <div class="sort-part" ref="tabs">
                            <pg-tabs ref='tabs' :class="{ fixed }" :list="gameList" @change="changeTab"></pg-tabs>
                            <div class="pc-el">
                                <div class="search-btn-wrap" @click="toPage('/search')">
                                    <div class="search-btn">
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="category-list" v-if="curTab !== 'amigos' && curTab !== 'jogos'">
                            <div v-for="(item, index) in indexGameList" :key="index" class="category-item"
                                :id="'category_' + index">
                                <div class="category-title">
                                    <div class="title-warp">
                                        <img class="part-icon" :src="item.icon_after" alt="">
                                        <span class="title">{{ item.title }}</span>
                                    </div>
                                </div>
                                <div class="list">
                                    {{ item.more }}
                                    <div class="game-item" v-for="(game, gameIndex) in item.child" :key="gameIndex"
                                        @click="playGame(game)">
                                        <span class="tag" v-if="game.tag_type == 'best'">BEST</span>
                                        <span class="tag hot" v-if="game.tag_type == 'hot'">HOT</span>
                                        <div class="game-sc" v-if="game.tag_code == 'popular'"></div>
                                        <span class="game-title">{{ game.title }}</span>
                                        <i class="game-bg-icon">
                                            <Icon type="game-load-bg" />
                                        </i>
                                        <img class="game-img" :src="game.img_url_2" alt="" @load="handlerLoadImage()">

                                        <!-- is_maintenance -->
                                        <div class="maintenance-wrap" v-if="game.is_maintenance">
                                            <img class="maintenance" src="@/assets/images/mask.png" alt="">
                                        </div>
                                        <div class="mask-play" v-else>
                                            <div class="play-btn">
                                                <div class="play">
                                                    <Icon type="arrow-right" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                </div>
                                <div class="more-wrap"
                                    v-if="item.originChild.length > (Layout.isPc ? 12 : 9) && item.child.length !== item.originChild.length">
                                    <div class="more">
                                        {{ $t('more_1') }} {{ Layout.isPc ? 12 : 9 }} {{ $t('more_2') }}
                                        {{ item.originChild - Layout.isPc ? 12 : item.originChild.length }} {{
        $t('more_3') }}</div>
                                    <div class="more-arrow" @click="loadMore(item)"> {{ $t('Load_More') }} <Icon
                                            class="arrow-db" type="more">
                                        </Icon>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div v-else-if="gameList?.[currentTab]?.length > 0" class="category-list">
                            <div class="category-item">
                                <div class="list">
                                    <div class="game-item" v-for="(game, gameIndex) in gameList[currentTab]"
                                        :key="gameIndex" @click="playGame(game)">
                                        <span class="game-title">{{ game.title }}</span>
                                        <img class="game-img" :src="game.img_url" alt="" @load="handlerLoadImage()">
                                        <div class="mask-play">
                                            <div class="play-btn">
                                                <div class="play">
                                                    <Icon type="arrow-right" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                    <div class="game-item-slot"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="category-list ">
                            <div class="empty-wrap">
                                <empty />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobile-el">
                    <PgDrawer :visible.sync="sliderShow" @close="closeSlider" :model="false">
                        <div class="drawer-slider">
                            <div style="padding-bottom: 1rem;">
                                <slider @menuClick="menuClick" @showMission="$refs.mission.show()" />
                            </div>
                        </div>
                    </PgDrawer>
                </div>

                <div class="fixed-br">

                </div>
            </div>
            <pg-footer></pg-footer>
            <div class="fix-ad-left sys-pop-wrap" v-if="fixBannerTopLeft.length > 0 || fixBannerBottomLeft.length > 0">
                <div class="fix-banner-box">
                    <swiper :options="fixBannerTopLeftOptions" ref="fixBannerTopLeft">
                        <swiper-slide v-for="(item, index) in fixBannerTopLeft" :key="index">
                            <div class="fix-banner-item">
                                <img class="swiper-item-img" :src="item.pic_url" alt="">
                                <div class="close">
                                    <Icon type='close' />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="fix-banner-box">
                    <swiper :options="fixBannerBottomLeftOptions" ref="fixBannerBottomLeft">
                        <swiper-slide v-for="(item, index) in fixBannerBottomLeft" :key="index">
                            <div class="fix-banner-item">
                                <img class="swiper-item-img" :src="item.pic_url" alt="">
                                <div class="close">
                                    <Icon type='close' />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="fix-ad-right sys-pop-wrap">

                <div class="fix-banner-box">
                    <swiper :options="fixBannerTopRightOptions" ref="fixBannerTopRight">
                        <swiper-slide v-for="(item, index) in fixBannerTopRight" :key="index">
                            <div class="fix-banner-item">
                                <img class="swiper-item-img" :src="item.pic_url" alt="">
                                <div class="close">
                                    <Icon type='close' />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="fix-banner-box">
                    <swiper :options="fixBannerBottomRightOptions" ref="fixBannerBottomRight">
                        <swiper-slide v-for="(item, index) in fixBannerBottomRight" :key="index">
                            <div class="fix-banner-item">
                                <img class="swiper-item-img" :src="item.pic_url" alt="">
                                <div class="close">
                                    <Icon type='close' />
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="return-top-wrap" v-show="showReturnTop" @click="returnTop">
                    <i class="icon-top">
                        <Icon type="returnTop" />
                    </i>
                    <span class="top-text">Topo</span>
                </div>
            </div>
        </div>
        <div id="home-content" class="home-loading-wrap  " v-else>
            <div class="main-content ml02 mr02">
                <div class="bg-block ">
                    <div class="banner-item-loading loading-animation"></div>
                </div>
                <div class="bg-block row column-c">
                    <div class="circle-block loading-animation"></div>
                    <div class="notice-line loading-animation"></div>
                </div>

                <div class="bg-block row">
                    <div class="tab-block loading-animation b-redius" v-for="item of 6" :key="item"></div>
                </div>

                <div class="bg-block">
                    <div class="row column-c">
                        <div class="circle-block loading-animation"></div>
                        <div class="line-title loading-animation b-redius"></div>
                    </div>
                    <div class="game-list-loading" v-if="Layout.isPc">
                        <div class="game-item-loading loading-animation" v-for="item of 12" :key="item"></div>
                    </div>
                    <div class="game-list-loading" v-else>
                        <div class="game-item-loading loading-animation" v-for="item of 9" :key="item"></div>
                    </div>
                </div>

            </div>
        </div>
        <Mission ref="mission" />

        <pg-poup transparent  v-model="adShow"
            @closed="adShow=false">
            <div class="sys-pop-wrap">
              <div class="tabs">
                <div class="tab-item" :class="{active: index === currentShowAdIndex}" v-for="(item, index) in adList" :key="index" @click="currentShowAdIndex = index">
                  <Icon type="message1" style="width: .28rem"/>
                  <div class="ad-title">{{ item.title }}</div>
                </div>
              </div>
                <img class="ad" :src="adList[currentShowAdIndex]?.content" alt="">
                <div class="close-ad">
                    <div class="close" @click="closeAd()">
                        <Icon type='close' />
                    </div>
                </div>
                <div class="row row-c">
                    <div class="mask-row">
                        <PgCheck v-model="noTipChecked" transparent @input="closeAd()"></PgCheck>
                        <span class="ml01 darken-color">{{ $t('dont_show') }}</span>
                    </div>
                </div>
            </div>
        </pg-poup>
    </div>
</template>

<script>
import Mission from '@/layout/components/Mission.vue';
import PgHeader from '@/layout/components/PgHeader.vue';
import SeamlessScroll from "@/components/SeamlessScroll.vue";
import slider from '@/layout/components/slider.vue'
import { apiGetNotices, apiGetAsidesList, apiGameLogin } from '@/api'
import { mapState } from 'vuex';
import { parseQueryString, copyText, getLocalTime } from '@/util'
import PgFooter from '@/layout/components/PgFooter.vue';
import Retirar from '@/layout/components/retirar'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
    name: "Index",
    data() {
        return {
            adList: [],
            isClose:false,
            swiperOption: {
                autoplay: {
                    delay: 5000
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // effect: 'coverflow',
                // slidesPerView: 2,
                // centeredSlides: true,
                // coverflowEffect: {
                //     rotate: 0,
                //     stretch: 10,
                //     depth: 160,
                //     modifier: 2,
                //     slideShadows: true
                // },

            },
            newsList: [],
            adShow:false,
            currentShowAdIndex:0,
            noTipChecked:false,
            noticeOptions: {
                openWatch: true,
                hoverStop: false,
                direction: 2,
                limitMoveNum: 1
            },
            fixBannerBottomRightOptions: {
                autoplay: {
                    delay: 5000
                },
                loop: true,
                on: {
                    click: (e) => {
                        const tagName = e.srcElement.tagName.toLowerCase();
                        const index = this.$refs.fixBannerBottomRight.swiperInstance.realIndex;
                        if (tagName === 'img') {
                            window.location.href = this.fixBannerBottomRight[index].quickurl.url
                        } else {
                            this.fixBannerBottomRight.splice(index, 1)
                        }
                    }
                }
            },
            fixBannerTopRightOptions: {
                autoplay: {
                    delay: 5000
                },
                loop: true,
                on: {
                    click: (e) => {
                        const tagName = e.srcElement.tagName.toLowerCase();
                        const index = this.$refs.fixBannerTopRight.swiperInstance.realIndex;
                        if (tagName === 'img') {
                            window.location.href = this.fixBannerTopRight[index].quickurl.url
                        } else {
                            this.fixBannerTopRight.splice(index, 1)
                        }
                    }
                }
            },
            fixBannerTopLeftOptions: {
                autoplay: {
                    delay: 5000
                },
                loop: true,
                on: {
                    click: (e) => {
                        const tagName = e.srcElement.tagName.toLowerCase();
                        const index = this.$refs.fixBannerTopLeft.swiperInstance.realIndex;
                        if (tagName === 'img') {
                            window.location.href = this.fixBannerBottomLeft[index].quickurl.url
                        } else {
                            this.fixBannerTopLeft.splice(index, 1)
                        }
                    }
                }
            },
            fixBannerBottomLeftOptions: {
                autoplay: {
                    delay: 5000
                },
                loop: true,
                on: {
                    click: (e) => {
                        const tagName = e.srcElement.tagName.toLowerCase();
                        const index = this.$refs.fixBannerBottomLeft.swiperInstance.realIndex;
                        if (tagName === 'img') {
                            window.location.href = this.fixBannerBottomLeft[index].full_url
                        } else {
                            this.fixBannerBottomLeft.splice(index, 1)
                        }
                    }
                }
            },
            fixBannerTopLeft: [],
            fixBannerTopRight: [],
            fixBannerBottomLeft: [],
            fixBannerBottomRight: [],
            tabTop: -1,
            headerHeight: -1,
            scrollTop: 0,
            fixed: false,
            currentLang: 1,
            showReturnTop: false,
            pageLoading: false,
            elementOffsetTopList: [],
            loadedImage: 0,
            originList: [],
            indexGameList: [],
            loading: false,
            last_JPCount: 0,
            cur_JPCount: '',
            curTab:'',
        }
    },
    components: { SeamlessScroll, slider, PgHeader, Mission, PgFooter },
    inject: ['Layout'],
    computed: {
        ...mapState({
            siteInfo: state => state.home.siteInfo,
            userInfo: state => state.user.userInfo,
            gameList: state => state.home.gameList,
            sliderShow: state => state.home.sliderShow,
            currentTab: state => state.home.currentTab,
            isScroll: state => state.home.isScroll,
            gameListLoading: state => state.home.gameListLoading,
            bannerList: state => state.home.bannerList
        }),
        // currentTagCode() {
        //     return this.gameList[this.currentTab]?.tag_code
        // },
        totalImage() {
            let total = 0;
            this.bannerList?.forEach(item => {
                total++;
            })
          console.log('gameList----',this.gameList)
            this.gameList.forEach(item => {
                total += item.child.length;
            })
            return total
        },
    },
    created() {
        console.log('creted')
        if (window.location.href.includes('amp')) {
            let new_url = window.location.href.replace("amp%3B", "")
            window.location.replace(new_url);
        }
        this.getNotice()
        this.getAsidesList()
    },
    mounted() {

        if (!localStorage.getItem('token')) {
            if (this.$route.query.id) {
                this.Layout.$refs.loginPop.type = 'register'
            } else {
                this.Layout.$refs.loginPop.type = 'login'
            }
            this.Layout.visible = true
        }
        if (window.addEventListener) {
            document.addEventListener("wheel", (e) => {
                this.$store.commit('SET_CURRENT_TAB_ISSCROLL', true)
            })
        } else {
            document.attachEvent("onmousewheel", (e) => {
                this.$store.commit('SET_CURRENT_TAB_ISSCROLL', true)
            })
        }
        this.last_JPCount = this.getJackPotData()
        this.updateJackPot(this.last_JPCount);
        setInterval(() => {

            let count = 0;
            let curData = this.getJackPotData()
            let dur = (curData - this.last_JPCount) / 20
            let schId = setInterval(() => {
                count++
                if (count >= 20) {
                    clearInterval(schId)
                    this.last_JPCount = curData;
                    return
                }
                this.last_JPCount += dur
                this.updateJackPot(this.last_JPCount);
            }, 50);
        }, 5000);
    },
    beforeDestroy() {
        console.log('beforeDestroy')
    },
    watch: {
        // currentTab: {
        //     handler(index) {
        //         if (this.currentTagCode === 'clube') {
        //             this.$router.push('/game_list?plat=all')
        //             return
        //         }
        //         this.$nextTick(() => {
        //             if (!this.isScroll) {
        //                 this.menuClick(index)
        //             }
        //         })
        //     }
        // },
        gameList: {
            handler(val) {
                this.originList = this.gameList.map(item => {
                    item.originChild = item.child;
                    let tempChild = [...item.originChild]
                    item.child = tempChild.splice(0, this.Layout.isPc ? 12 : 9)
                    return item
                })
                this.indexGameList = this.originList.filter(item => (item.tag_code !== "clube" && item.tag_code !== "amigos" && item.tag_code !== "jogos"))
            },
            immediate: true
        },
        cur_JPCount: {
            deep: true,
            handler() {
                this.$forceUpdate()
            }
        }
    },
    activated() {
        if (this.$refs.homePage) {
            this.$refs.homePage.scrollTop = this.scrollTop;
        }
    },
    methods: {
        loadMore(item) {
            item.child = [...item.originChild]
        },
        changeTab(e){
          this.curTab = e.tag_code;
          console.log(e.tag_code)
          if(e.tag_code === 'amigos' || e.tag_code === 'jogos'){
            this.fixed=false;
          }
        },
        getAsidesList() {
            apiGetAsidesList().then(res => {
                res.data.forEach(item => {
                    if (item.vertical === 'top') {
                        if (item.horizontal === 'left') {
                            this.fixBannerTopLeft = item.advs
                            if (item.advs.length < 2) {
                                this.fixBannerTopLeftOptions.loop = false
                            }
                        } else if (item.horizontal === 'right') {
                            if (item.advs.length < 2) {
                                this.fixBannerTopRightOptions.loop = false
                            }
                            this.fixBannerTopRight = item.advs
                        }
                    }
                    if (item.vertical === 'bottom') {
                        if (item.horizontal === 'left') {
                            if (item.advs.length < 2) {
                                this.fixBannerBottomLeftOptions.loop = false
                            }
                            this.fixBannerBottomLeft = item.advs
                        }
                        if (item.horizontal === 'right') {
                            if (item.advs.length < 2) {
                                this.fixBannerBottomRightOptions.loop = false
                            }
                            this.fixBannerBottomRight = item.advs
                        }
                    }

                })
            })
        },
        getNotice() {
            apiGetNotices().then(res => {
                this.adList = res.alert
                this.currentShowAdIndex = 0
                this.newsList = res.data
                const adStorageDate = localStorage.getItem('hiddenAdDate')
                if (adStorageDate) {
                    const now = getLocalTime(-3)
                    if (adStorageDate === `${now.getMonth() + 1}${now.getDate()}`) {
                        this.adShow = false
                    } else {
                        localStorage.removeItem('hiddenAdDate')
                        this.adShow = true
                    }
                }else{
                  this.adShow = true
                }
            })

        },
        handlerLoadImage() {
            this.loadedImage++;
            if (this.loadedImage === this.totalImage) {
                this.getGameElOffsetTop()
            }
        },
        getGameElOffsetTop() {
            this.$nextTick(() => {
                this.elementOffsetTopList = []
                this.gameList.forEach((item, index) => {
                    const itemEl = document.getElementById('category_' + index);
                    const headerHeight = document.querySelector('#mobile-header')?.clientHeight || 0;
                    const tabHeight = document.querySelector('.tab-scroll-content .scroll-body').clientHeight;
                    if (itemEl) {
                        this.elementOffsetTopList.push(itemEl.offsetTop - headerHeight - tabHeight + itemEl.clientHeight)
                    }

                })
            })
        },
        checkSame() {
            this.$nextTick(() => {
                const itemEl = document.getElementById('category_' + 0);
                if(!itemEl) return
                const headerHeight = document.querySelector('#mobile-header .header')?.clientHeight || 0;
                const tabHeight = document.querySelector('.tab-scroll-content .scroll-body').clientHeight;
                const result = itemEl.offsetTop - headerHeight - tabHeight + itemEl.clientHeight;
                if (this.elementOffsetTopList.length > 0 && result !== this.elementOffsetTopList[0]) {
                    this.getGameElOffsetTop()
                    return
                }
            })
        },
        closeAd() {
            setTimeout(() => {
                if (this.noTipChecked) {
                    const now = getLocalTime(-3)
                    let adHidden = `${now.getMonth() + 1}${now.getDate()}`
                    localStorage.setItem('hiddenAdDate', adHidden)
                }
            }, 100)
        },
        copy(text) {
            copyText(text)
        },
        touchmove() {
            this.$store.commit('SET_CURRENT_TAB_ISSCROLL', true)
        },
        handleScroll(e) {
            this.checkSame()
            if (this.currentTagCode == 'amigos' || this.currentTagCode == 'jogos') {
                return
            }
            let scrollTop = this.scrollTop = e.target.scrollTop
            if (scrollTop >= 250) {
                this.showReturnTop = true
            } else {
                this.showReturnTop = false
            }

            if (scrollTop <= 0) {
                this.$refs.homePage.scrollTop = 0;
            }

            if (this.tabTop < 0) {
                this.tabTop = this.$refs.tabs.offsetTop
            }
            if (this.headerHeight < 0) {
                this.headerHeight = document.querySelector('#mobile-header .header').clientHeight
            }
            if (this.isScroll) {
                this.getNearIndex(scrollTop)
            }
            const tabTop = this.tabTop
            let headerHeight = this.headerHeight
            if (!this.Layout.isPc) {
              console.log('scrollTop',scrollTop);
                this.fixed = scrollTop >= tabTop - headerHeight;
            }
        },
        getNearIndex(scrollTop) {
            for (let index = 0; index < this.elementOffsetTopList.length; index++) {
                const item = this.elementOffsetTopList[index];
                if (scrollTop < item) {
                    this.$store.commit('SET_CURRENT_TAB_ISSCROLL', true)
                    this.$store.commit('SET_CURRENT_TAB', index)
                    break
                }
            }
        },
        returnTop() {
            this.$refs.homePage.scrollTop = 0;
        },
        scrollIntoView(index) {
            if (document.getElementById('category_' + index)) {
                this.$refs.homePage.scrollTo({
                    top: document.getElementById('category_' + index).offsetTop - document.querySelector('.header').clientHeight - document.querySelector('.sort-part').clientHeight - document.querySelector('.category-title').offsetHeight - 10,
                    behavior: 'smooth'
                })
            }
        },
        closeSlider() {
            if (!this.Layout.isPc) {
                this.$store.commit('SET_SLIDER_SHOW', false)
            }
        },
        menuClick(index) {
            this.closeSlider()
            if (this.currentTagCode == 'amigos' || this.currentTagCode == 'jogos') {
                this.returnTop()
                return
            }
            this.scrollIntoView(index)
        },
        bannerClick(item) {
            if (item.jump_link) {
                if (item.is_new_window) {
                    window.open(item.jump_link)
                } else {
                    location.href = item.jump_link
                }
            }
        },
        playGame(item) {
            if (localStorage.getItem('token')) {
                if (item.is_maintenance) {
                    return
                }
                if (item.open_type == 1) {
                    if (item.url.startsWith('http')) {
                        window.location.href = window.location.origin + item.url
                    } else {
                        this.$router.push(item.url)
                    }
                } else {
                    if (this.loading) return
                    const { game_id } = parseQueryString(item.url)
                    const data = {
                        game_id
                    }
                    this.loading = true;
                    apiGameLogin(data).then(res => {
                        this.loading = false;
                        if (res.game_url) {
                            localStorage.setItem('gameUrl', res.game_url)
                            this.$router.push(`/game?game_id=${game_id}&name=${item.title}`)
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    }).catch((err) => {
                        console.log(err)
                        this.loading = false;
                    })
                }
            } else {
                this.Layout.$refs.loginPop.type = 'login'
                this.Layout.visible = true
            }
        },
        toPage(url) {
            this.$router.push(url)
        },
        open(url) {
            window.open(url)
        },
        updateJackPot(count) {
            const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            let seconds = this.padDecimalToTwo(formatter.format(parseFloat((count).toFixed(2))));
            this.cur_JPCount = seconds;

            // this.jack_pot = []
            // for (const str of seconds) {
            //     let name = 'g-' + str;
            //     if (str == '.') {
            //         name = 'g-decimal'
            //     }else if(str == ','){
            //         name = 'g-comma'
            //     }
            //     this.jack_pot.push(name)
            // }
            // console.log(this.jack_pot);
        },
        getJackPotData() {
            //let base = 50000000
            let now = new Date();
            let start = new Date(now.getFullYear(), 0, 0);
            let secondsInDay = 86400;
            let oneDay = 1000 * 60 * 60 * 24;

            let seconds = Math.floor((now.getTime() - start.getTime()) / 1000);
            let base = 0
            for (let i = 0; i < now.getDate(); i++) {
                base += secondsInDay;
            }


            return seconds * 150 + base - 1000000000
        },
        padDecimalToTwo(str) {
            return str.replace(/^\d+(\.\d{1})?$/, function (match, p1) {
                return p1 ? match : `${match}.00`;
            });
        },
        getJPClass(str) {
            if (str == '.') {
                return 'g-decimal'
            } else if (str == ',') {
                return 'g-comma'
            }
            return this.jack_pot[str]
        }
    }
}
</script>

<style lang="scss" scoped>
#home-page {
    display: flex;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    .sys-pop-wrap {
        width: 6.5rem;
        .tabs{
          display: flex;
          white-space: nowrap;
          background: var(--theme-main-bg-color);
          .tab-item{
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: .2rem;
            text-align: revert;
            position: relative;
            height: 100%;
            max-width: 1.6rem;
            margin-left: .2rem;
            color: var(--theme-text-color-lighten);
            &.active{
              color: var(--theme-mine-icon-color);
            }
            .ad-title{
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              display: -webkit-box;
              white-space: break-spaces;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: .22rem;
              width: 1.4rem;
              margin-left: 0.1rem;
            }
          }
        }
        .ad {
            border-radius: 0.2rem;
            width: 100%;
        }

        .mask-row {
            font-size: .22rem;
            background-color: rgba(0, 0, 0, .6);
            border-radius: 0.1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.1rem 0.15rem 0.1rem 0.1rem;
        }
    }

    #home-content {
        padding-top: 1.58rem;
        padding-bottom: 1.24rem;
        box-sizing: border-box;
        overflow-y: scroll;
        overflow-x: hidden;
        flex: 1;
        background: var(--theme-main-bg-color);
        width: 100%;
        height: 100%;
        transition: padding-top 0.5s;
        background-image: url('@/assets/images/bg_pattern_tile 6.png');

        &.is-close{
          padding-top: 0.88rem;
        }

        &.home-loading-wrap {
            background: var(--theme-bg-color);

            .bg-block {
                background: var(--theme-main-bg-color);
                padding: 0.1rem;
                margin-top: 0.1rem;
                border-radius: 0.12rem;

                .banner-item-loading {
                    width: 100%;
                    height: 2.5rem;
                    margin: 0.1rem 0;
                    border-radius: 0.12rem;
                }

                .circle-block {
                    border-radius: 50%;
                    height: 0.28rem;
                    width: 0.28rem
                }

                .notice-line {
                    flex: 1;
                    height: 0.1rem;
                    border-radius: 0.12rem;
                    margin-left: 0.1rem;
                }

                .tab-block {
                    height: 0.6rem;
                    width: 0.95rem;
                    margin-right: 0.1rem;
                }

                .line-title {
                    height: 0.08rem;
                    margin-left: 0.06rem;
                    width: 0.8rem;
                }

                .game-list-loading {
                    display: flex;
                    flex-wrap: wrap;
                    padding: 0 0.1rem;
                    justify-content: space-between;

                    .game-item-loading {
                        border-radius: 0.12rem;
                        margin-top: 0.16rem;
                        width: calc(33.333% - 0.19rem);
                        height: 2.93rem;
                    }
                }

            }
        }

        .notice-wrap {
            max-width: 12rem;
            margin: 0 auto;
            padding: .2rem;
            font-size: .22rem;
            color: var(--theme-text-color);

            .notice-container {
                display: flex;
                height: 0.88rem;
                box-sizing: border-box;
                align-items: center;
                padding: .22rem 0;
            }

            ::v-deep .swiper-pagination-bullet {
                width: .11rem;
                height: .11rem;
                border: thin solid rgba(0, 0, 0, .2);
                background-color: hsla(0, 0%, 100%, .5);

                &.swiper-pagination-bullet-active {
                    background: #fff;
                    border: #fff;
                }
            }

            .icon-notice {
                width: 0.36rem;
                height: 0.32rem;
                margin-right: .1rem;
            }

            .notice-row {
                width: 5.9rem;
                flex: 1;
                height: 0.36rem;
                line-height: 0.36rem;
                overflow: hidden;

                .notice-list {
                    white-space: nowrap;

                    .notice-item {
                        display: inline-block;
                        font-weight: bold;
                    }
                }
            }

            .icon-msg {
                display: inline-block;
                position: relative;
                width: 0.5rem;
                height: 0.4375rem;
                background-image: var(--bgUrl);
                background-position: -0.66875rem -4.6375rem;
                background-size: 6.5rem 6.0125rem;
            }

            .main-banner {
                position: relative;

                .swiper-container{
                    border-radius: .35rem;
                }

                .swiper-button-prev {
                    &::after {
                        content: '';
                        font-size: 0 !important;
                    }
                }

                .swiper-button-next {
                    &::after {
                        content: '';
                        font-size: 0 !important;
                    }
                }

                .arrow {
                    background-color: rgba(0, 0, 0, 0.2);
                    border: 0.01rem solid rgba(255, 255, 255, 0.1);
                    border-radius: 0.18rem;
                    top: 0.11rem;
                    color: rgb(255, 255, 255);
                    cursor: pointer;
                    height: 0.36rem;
                    line-height: 0.36rem;
                    margin: 0.18rem 0px;
                    text-align: center;
                    width: 0.36rem;
                    position: absolute;
                    display: inline-block;
                    align-items: center;
                    justify-content: center;
                    font-size: .14rem;
                    padding-top: 0.01rem;
                    box-sizing: border-box;
                    z-index: 9;

                    &.right {
                        right: 0;
                    }

                    &.left {
                        left: 0;
                        transform: rotate(-180deg);
                    }
                }

                .swiper-item {
                    border-radius: .2rem;

                    .swiper-item-img {
                        width: 100%;
                        height: 100%;
                        border-radius: .2rem;
                    }
                }
            }

            .jack-pot {
                -ms-flex-align: center;
                -ms-flex-pack: center;
                align-items: center;
                display: -ms-flexbox;
                display: flex;
                justify-content: center;

                .jp-bg {
                    background-position: 0px 0px;
                    background-image: url(@/assets/images/cjc1_style_0_bg.png);
                    background-size: 100% 100%;
                    cursor: pointer;
                    height: 2.71rem;
                    position: relative;
                    width: 100%;

                    .count-box {
                        -ms-flex-align: center;
                        -ms-flex-pack: center;
                        align-items: center;
                        bottom: 0.43rem;
                        display: -ms-flexbox;
                        display: flex;
                        height: 1.18rem;
                        justify-content: center;
                        left: .4rem;
                        position: absolute;
                        right: 0;

                        .count-to {
                            -ms-flex-pack: center;
                            display: -ms-flexbox;
                            display: flex;
                            justify-content: center;
                            -ms-flex-align: center;
                            align-items: center;
                            letter-spacing: 0.0413rem;
                            -webkit-transform: scale(1);
                            transform: scale(1);
                            font-weight: 700;
                            font-size: .8rem;
                            color: #FFFF82;

                            li {
                                -ms-flex-pack: center;
                                display: -ms-flexbox;
                                display: flex;
                                justify-content: center;

                                .g-number {
                                    //background-image: url(@/assets/images/goldNumber.png);
                                    display: inline-block;
                                    position: relative;
                                }

                                .g-0 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-size: 6.62rem .83rem;
                                    background-position: -3px 2px;
                                }

                                .g-1 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -44.5px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-2 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -86px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-3 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -127.5px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-4 {

                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -169px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-5 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -210.5px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-6 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -250px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-7 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -290px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-8 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -332px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-9 {
                                    width: 0.53rem;
                                    height: 0.83rem;
                                    background-position: -373px 2px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-comma {
                                    width: 0.36rem;
                                    height: 0.83rem;
                                    background-position: -410px 32px;
                                    background-size: 6.62rem .83rem;
                                }

                                .g-decimal {
                                    width: 0.36rem;
                                    height: 0.83rem;
                                    background-position: -432px 36px;
                                    background-size: 6.62rem .83rem;
                                }
                            }
                        }
                    }
                }
            }
        }

        .main-content {
            .sort-part {
                height: 1.1rem;
                display: flex;
                justify-content: space-between;
                position: sticky;
                top: 0;
                z-index: 9;

                .search-btn-wrap {
                    height: 100%;
                    font-size: 0;

                    .search-btn {
                        width: 0.43rem;
                        height: 0.37625rem;
                        margin-left: 0.16rem;
                        margin-top: 0.12rem;

                        i {
                            display: inline-block;
                            position: relative;
                            width: 100%;
                            height: 100%;
                            background-image: var(--bgUrl);
                            background-position: -4.2rem -2.76rem;
                            background-size: 5.8265rem 5.79962rem;
                        }
                    }
                }

                .fixed {
                    position: fixed;
                    top: .89rem;
                    left: 0;
                    right: 0;
                    z-index: 3;
                    background: var(--theme-home-bg);
                }
            }

            .category-list {
                padding: 0 .3rem .4rem .3rem;

                .empty-wrap {
                    padding-top: 0.2rem;
                }

                .category-item {
                    padding: .1rem 0;

                    .more-wrap {
                        margin-top: .3rem;
                        font-size: .22rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        user-select: none;

                        .more {
                            color: var(--theme-text-color-lighten);
                        }

                        .more-arrow {
                            margin-left: 0.2rem;
                            color: var(--theme-text-color);
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            user-select: none;

                            .arrow-db {
                                margin-left: 0.2rem;
                                font-size: 0.12rem
                            }
                        }
                    }

                    .category-title {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding-bottom: 0.1rem;

                        .title-warp {
                            display: flex;
                            align-items: center;

                            .part-icon {
                                width: 0.52rem;
                                height: 0.52rem;
                                margin-right: 0.1rem;
                                object-fit: contain;
                            }

                            .title {
                                font-size: .3rem;
                                color: var(--theme-text-color-darken);
                            }

                        }

                    }

                    .list {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        justify-content: space-between;

                        .game-item {
                            font-size: 0;
                            margin: 0.15rem 0;
                            width: 30.5%;
                            border-radius: .2rem;
                            overflow: hidden;
                            position: relative;
                            user-select: none;
                            cursor: pointer;
                            z-index: 1;

                            .maintenance-wrap {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                                justify-content: center;
                                align-items: center;
                                z-index: 9;
                                background: rgba(0, 0, 0, .4);

                                .maintenance {
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    width: 1rem;
                                    transform: translate(-50%, -50%);
                                }
                            }

                            .mask-play {
                                display: none;
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                height: 100%;
                                justify-content: center;
                                align-items: center;
                                z-index: 9;
                                background: rgba(0, 0, 0, .4);


                                .play-btn {
                                    width: .6rem;
                                    height: .6rem;
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    border-radius: 50%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    background: var(--theme-primary-color);
                                    transform: translate(-50%, -50%);

                                    .play {
                                        font-size: .4rem;
                                        color: var(--theme-primary-font-color);
                                        position: relative;
                                        left: 0.05rem;
                                        top: 0.04rem;
                                    }
                                }
                            }

                            .game-img {
                                width: 100%;
                            }

                            .tag {
                                font-size: 0.2rem;
                                align-items: center;
                                color: var(--theme-text-color-activities-text);
                                display: -ms-flexbox;
                                display: flex;
                                height: 0.3rem;
                                justify-content: center;
                                left: -0.02rem;
                                padding: 0.02rem 0.1rem 0.02rem 0.08rem;
                                position: absolute;
                                top: 0;
                                border-radius: 0.14rem 0.2rem 0.2rem 0;
                                font-weight: 700;
                                z-index: 99;
                                background-color: var(--theme-secondary-color-error);
                            }

                            .hot {
                                background-color: #FFFF54;
                                color: var(--theme-secondary-color-error);
                            }


                            .game-bg-icon {
                                z-index: -1;
                                -ms-flex-align: center;
                                -ms-flex-pack: center;
                                align-items: center;
                                display: -ms-flexbox;
                                display: flex;
                                height: 100%;
                                justify-content: center;
                                left: 0;
                                position: absolute;
                                top: 0;
                                width: 100%;
                                font-size: 1.03rem;
                                --fallback-background-image: initial;
                            }

                            .game-sc {
                                width: 0.34rem;
                                height: 0.34rem;
                                position: absolute;
                                top: .1rem;
                                right: 0.1rem;
                                background-position: 0px 0px;
                                background-image: url(@/assets/images/btn_sc_off_2.png);
                                background-size: 100% 100%;
                                z-index: 8;
                            }

                            .game-title {
                                bottom: .08rem;
                                color: #fff;
                                left: 0;
                                z-index: 1;
                                padding: 0.02rem 0.02rem;
                                position: absolute;
                                right: 0;
                                font-size: .24rem;
                                text-align: center;

                            }
                        }

                        .game-item-slot {
                            height: 0;
                            width: 2.2rem;
                        }

                    }
                }
            }
        }

        .drawer-slider {
            padding-top: 0.88rem;
            height: 100%;
            box-sizing: border-box;
            overflow-y: auto;
            background: var(--theme-main-bg-color);
        }


    }

    .fix-ad-left {
        width: 1.5rem;
        bottom: 1.44rem;
        left: 0.1rem;
        position: fixed;
    }

    .sys-pop-wrap {

        .fix-banner-box {
            width: 1.6rem;
            height: 1.6rem;
            margin-top: 0.2rem;

            .swiper-slide {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .fix-banner-item {
            width: 1.5rem;
            height: 1.5rem;
            position: relative;

            .swiper-item-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }

            .close {
                height: 0.3rem;
                position: absolute;
                right: 0;
                top: 0;
                font-size: .2rem;
                display: flex;
                justify-content: flex-end;
                color: var(--theme-text-color-lighten);
                width: 0.3rem;
                z-index: 9999;
                cursor: pointer;
            }
        }
    }

    .fix-ad-right {
        width: 1.5rem;
        bottom: 1.44rem;
        right: 0.1rem;
        position: fixed;
        z-index: 9;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .return-top-wrap {
            margin-top: 0.2rem;
            width: 1.1rem;
            border-radius: 0.14rem;
            min-height: 1rem;
            box-sizing: border-box;
            padding: 0.14rem 0.05rem 0.04rem;
            align-items: center;
            background-color: var(--theme-main-bg-color);
            border: 0.01rem solid var(--theme-color-line);
            box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, .1);
            cursor: pointer;
            display: flex;
            flex-direction: column;
            text-align: center;

            .icon-top {
                font-size: .26rem;
                height: 0.38rem;
                margin-bottom: 0.08rem;
                width: 0.38rem;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                background-color: var(--theme-primary-color);
                border-radius: 50%;
                color: var(--theme-primary-font-color);
            }

            .top-text {
                font-size: .18rem;
                color: var(--theme-text-color-lighten);
            }
        }


    }
}

.mobile-page {
    .arrow {
        display: none !important;
    }

    .category-item:not(:last-child) {
        border-bottom: none;
    }
}

.pc-page {
    #home-page {
        #home-content {
            background: none;
            flex: 1;
            padding-top: 0;
            padding-bottom: 0;

            &.home-loading-wrap .bg-block .game-list-loading .game-item-loading {
                width: calc(16.66667% - 0.19rem);
                height: 2.26rem;
            }

            .main-content {
                max-width: 12rem;
                margin: 0 auto;
                padding: 0 .2rem;
                border-radius: .1rem;

                .category-item:not(:last-child) {
                    border-bottom: 0.01rem solid var(--theme-color-line);
                }

                .category-list .category-item {
                    .list {

                        .game-item-slot {
                            width: 15%;
                        }

                        .game-item {
                            width: 15%;

                            &:hover .mask-play {
                                display: inline-flex;
                            }
                        }

                    }

                }

                .m-bg {
                    border-radius: 0.1rem;
                    background-color: var(--theme-main-bg-color);
                    box-shadow: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, .06);
                }

                .sort-part {
                    margin-left: 0.2rem;

                    .fixed {
                        position: relative;
                        background: transparent;
                    }
                }
            }

            .notice-wrap .notice-container {
                padding: .06rem .2rem;
                border-radius: .1rem;
                margin-top: .2rem;
                background-size: 0 0.03rem 0.09rem 0 rgba(0, 0, 0, .06);
                background-color: var(--theme-main-bg-color);
            }

        }

        .slider-body {
            width: 3rem;
            padding-top: 0.88rem;
        }
    }

    .sys-pop-wrap {

        .close-ad {
            -ms-flex-align: center;
            -ms-flex-pack: center;
            align-items: center;
            border-radius: 50%;
            cursor: pointer;
            display: -ms-flexbox;
            display: flex;
            height: 0.4rem;
            justify-content: center;
            position: absolute;
            right: -0.4rem;
            top: -0.4rem;
            width: 0.4rem;

            .close {
                cursor: pointer;
                position: absolute;
                right: -0.2rem;
                top: 50%;
                transform: translateY(-50%);
                font-size: .35rem;
                display: inline-block;
                color: var(--theme-text-color);
                height: 0.56rem;
                line-height: .56rem;
                width: 0.56rem;
            }
        }

        .fix-banner-box {
            width: 1rem;
        }
    }
}

.mobile-page{
    .sys-pop-wrap {
        .close-ad {
            display: none;
        }
    }

    .jack-pot {
        margin-top: 0.2rem;

        .jp-bg {

            height: 1.64rem !important;

            .count-box {
                height: 0.76rem !important;
                bottom: 0.245rem !important;

                .notranslate {
                    font-size: .4rem !important;
                }
            }
        }
    }


    .sort-part {
        background: var(--theme-home-bg)
    }
}
</style>
